module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAApUlEQVR42p2SBw3DUAxED4IhBEIhFEIglEnLoGXwIQTCh2DN7gHFPUfK3v+k7DyfF+ZkHxyRInthT9j8uh1+I5bwFzHNlcdqd/shswdyumkb5qFlwCd2g6bw+PGwDYfyOLubVE6bYIVU6QpfFCvBogL7JYQFMMyNJ5+FnzjMjeg0C79xmYb7db8R+/VOwq2uB7shA+XXVi9+Uwsi7lQtQl9VkHan/4x3LP6qSziRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/star.png
// module id = 344
// module chunks = 6